// src/js/redesignAccordion.js
// Accepts optional root element for scoped initialization
export function redesignAccordion(root) {
  const accordions = root
    ? root.querySelectorAll(".redesign-accordion")
    : document.querySelectorAll(".redesign-accordion");
  accordions.forEach((accordion) => {
    // Prevent duplicate event listeners
    if (accordion.__redesignAccordionInitialized) return;
    accordion.__redesignAccordionInitialized = true;
    accordion.querySelectorAll(".accordion-toggle").forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const item = this.closest(".accordion-item");
        const contentWrapper = item.querySelector(".accordion-content-wrapper");
        const chevronDown = this.querySelector(".chevron-down");
        const chevronUp = this.querySelector(".chevron-up");
        const expanded = this.getAttribute("aria-expanded") === "true";
        
        // Close all other items unless this is a standalone (non-tabbed) accordion
        const isTabbed = !!accordion.closest(".redesign-tabbed-accordion");
        if (isTabbed) {
          accordion.querySelectorAll(".accordion-item").forEach((itm) => {
            if (itm !== item) {
              const otherToggle = itm.querySelector(".accordion-toggle");
              const otherContentWrapper = itm.querySelector(".accordion-content-wrapper");
              const otherChevronDown = otherToggle.querySelector(".chevron-down");
              const otherChevronUp = otherToggle.querySelector(".chevron-up");
              const otherHeadingSpan = otherToggle.querySelector("span");
              if (otherToggle.getAttribute("aria-expanded") === "true") {
                otherContentWrapper.classList.remove("accordion-open");
                otherToggle.setAttribute("aria-expanded", "false");
                otherChevronDown.classList.remove("hidden", "rotate-180");
                otherChevronUp.classList.add("hidden");
                itm.setAttribute("data-expanded", "false");
                itm.classList.remove("active-accordion");
                if (otherHeadingSpan) otherHeadingSpan.classList.remove("font-bold");
              }
            }
          });
        }

        // Toggle only the clicked item
        const headingSpan = this.querySelector("span");
        if (expanded) {
          // Close
          contentWrapper.classList.remove("accordion-open");
          this.setAttribute("aria-expanded", "false");
          chevronDown.classList.remove("hidden", "rotate-180");
          chevronUp.classList.add("hidden");
          item.setAttribute("data-expanded", "false");
          item.classList.remove("active-accordion");
          if (headingSpan) headingSpan.classList.remove("font-bold");
        } else {
          // Open
          contentWrapper.classList.add("accordion-open");
          this.setAttribute("aria-expanded", "true");
          chevronDown.classList.add("hidden", "rotate-180");
          chevronUp.classList.remove("hidden");
          item.setAttribute("data-expanded", "true");
          item.classList.add("active-accordion");
          if (headingSpan) headingSpan.classList.add("font-bold");
        }
        // After toggling, update all heading spans to be bold if their button is expanded
        accordion.querySelectorAll(".accordion-item").forEach((itm) => {
          const btn = itm.querySelector(".accordion-toggle");
          const span = btn ? btn.querySelector("span") : null;
          if (btn) {
            if (btn.getAttribute("aria-expanded") === "true") {
              itm.classList.add("active-accordion");
              if (span) span.classList.add("font-bold");
            } else {
              itm.classList.remove("active-accordion");
              if (span) span.classList.remove("font-bold");
            }
          }
        });
      });
    });
  });
}
